import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

import routes from 'routes';
import styles from './AuthLayout.module.css';

import logoImage from 'assets/images/logo.png';
import MobileCurveImage from 'assets/images/mobile_sad.png';
import Footer from '../../components/common/Footer';

const AuthLayout = () => {
  const location = useLocation();

  const getBackgroundStyle = () => {
    switch (location.pathname) {
      case routes.auth.login:
        return styles.defaultBackground;
      case routes.auth.register:
        return styles.defaultBackground;
      case routes.auth.general:
        return styles.ownerDetailBackground;
      case routes.auth.plan:
        return styles.ownerDetailBackground;
      default:
        return styles.defaultBackground;
    }
  };

  return (
    <div
      className={`${styles.sectionHolder} ${getBackgroundStyle()} ${location.pathname === routes.auth.setupClub ? styles.ownerSetUpClubSectionHolder : ''}`}
    >
      <div className={styles.sectionHolderWrapper}>
        <div className={styles.sContent}>
          <Link to={routes.admin.dashboard} className={styles.logoImage}>
            <img src={logoImage} alt="logo" />
          </Link>
          <Outlet />
          <div className={styles.mobileCurve}>
            <img src={MobileCurveImage} alt="mobile_curve_image" />
          </div>
        </div>
      </div>
      {routes.auth.setupClub ? <Footer /> : null}
    </div>
  );
};

export default AuthLayout;
